import { Component, Input, OnInit } from '@angular/core';
import { SparePartsApiService } from 'src/app/api/spareParts/sparePartsApiService';
import { SparePartsResponse } from 'src/app/api/spareParts/sparePartsResponse';

@Component({
    selector: 'asset-spare-parts',
    templateUrl: './asset-spare-parts.component.html',
    styleUrls: ['./asset-spare-parts.component.css'],
    host: {'class': 'spare-parts-component'},
    standalone: false
})
export class AssetSparePartsComponent implements OnInit {
  @Input() assetId: string | undefined = undefined;
  loading: boolean = false;
  spareParts: SparePartsResponse | null = null;

  constructor(private sparePartsApiService: SparePartsApiService) { }

  ngOnInit(): void {
    if (!this.assetId)
      return;

    this.loading = true;
    this.sparePartsApiService.getAssetSpareParts(this.assetId).subscribe(x => {
      this.spareParts = x;
      this.loading = false;
    });
  }
}
